/**
 * Helper function to dynamically update meta tags in the document head
 * This is used as a fallback for WhatsApp link previews that may not correctly read React Helmet tags
 */
export const updateMetaTags = (
  title: string,
  description: string,
  imageUrl?: string,
  url?: string,
  siteName?: string
) => {
  // Update document title
  document.title = title;

  // Helper to get or create a meta tag
  const getOrCreateMetaTag = (name: string, property?: string): HTMLMetaElement => {
    // Try to find existing meta tag
    let meta: HTMLMetaElement | null = null;
    
    if (name) {
      meta = document.querySelector(`meta[name="${name}"]`);
    } else if (property) {
      meta = document.querySelector(`meta[property="${property}"]`);
    }
    
    // Create new meta tag if not found
    if (!meta) {
      meta = document.createElement('meta');
      if (name) meta.setAttribute('name', name);
      if (property) meta.setAttribute('property', property);
      document.head.appendChild(meta);
    }
    
    return meta;
  };

  // Update basic meta tags
  getOrCreateMetaTag('description').setAttribute('content', description);
  
  // Update OpenGraph tags
  getOrCreateMetaTag(null, 'og:title').setAttribute('content', title);
  getOrCreateMetaTag(null, 'og:description').setAttribute('content', description);
  getOrCreateMetaTag(null, 'og:type').setAttribute('content', 'website');
  
  if (url) {
    getOrCreateMetaTag(null, 'og:url').setAttribute('content', url);
  }
  
  if (imageUrl) {
    const absoluteImageUrl = imageUrl.startsWith('http') 
      ? imageUrl 
      : `${window.location.origin}${imageUrl}`;
    getOrCreateMetaTag(null, 'og:image').setAttribute('content', absoluteImageUrl);
  }
  
  if (siteName) {
    getOrCreateMetaTag(null, 'og:site_name').setAttribute('content', siteName);
  }
  
  // Update Twitter Card tags
  getOrCreateMetaTag('twitter:card').setAttribute('content', 'summary_large_image');
  getOrCreateMetaTag('twitter:title').setAttribute('content', title);
  getOrCreateMetaTag('twitter:description').setAttribute('content', description);
  
  if (imageUrl) {
    const absoluteImageUrl = imageUrl.startsWith('http') 
      ? imageUrl 
      : `${window.location.origin}${imageUrl}`;
    getOrCreateMetaTag('twitter:image').setAttribute('content', absoluteImageUrl);
  }
}; 